import React, { useState } from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";
import BrandHeader from "./components/BrandHeader";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import SuccessMessage from "./components/SuccessMessage";

export default function ForgotPasswordScreen() {
  const [isSuccess, setIsSuccess] = useState(false);
  const [sentEmail, setSentEmail] = useState("");

  const handleSuccess = (email) => {
    setSentEmail(email);
    setIsSuccess(true);
  };

  const handleRetry = () => {
    setIsSuccess(false);
    setSentEmail("");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 flex items-center justify-center p-4">
      {/* Background decorative blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-teal-700/10 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-md">
        <BrandHeader />

        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-2xl">
          {isSuccess ? (
            <SuccessMessage email={sentEmail} onRetry={handleRetry} />
          ) : (
            <>
              {/* Header */}
              <div className="mb-6">
                <div className="w-12 h-12 rounded-xl bg-teal-500/10 border border-teal-500/20 flex items-center justify-center mb-4">
                  <Icon name="KeyRound" size={22} color="#2dd4bf" />
                </div>
                <h1 className="text-2xl font-bold text-white font-heading">Forgot your password?</h1>
                <p className="text-slate-400 text-sm mt-1.5 font-body leading-relaxed">
                  No worries — enter your email and we'll send you a secure reset link.
                </p>
              </div>

              <ForgotPasswordForm onSuccess={handleSuccess} />

              {/* Security note */}
              <div className="mt-5 flex items-center gap-2 p-3 rounded-xl bg-white/3 border border-white/5">
                <Icon name="ShieldCheck" size={14} color="#64748b" />
                <p className="text-xs text-slate-500 font-caption">
                  Reset links are valid for 1 hour and can only be used once.
                </p>
              </div>
            </>
          )}

          {!isSuccess && (
            <div className="mt-6 text-center">
              <Link
                to="/login-page"
                className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors font-caption"
              >
                <Icon name="ArrowLeft" size={14} />
                Back to login
              </Link>
            </div>
          )}
        </div>

        <p className="text-center text-xs text-slate-600 mt-6 font-caption">
          © 2026 myfitnesstracking. All rights reserved.
        </p>
      </div>
    </div>
  );
}
